export default {
  message: {
    navigation: '返回首页',
    heard: '等待付款',
    orderTitle: '订单金额',
    exchangeRate: '固定汇率',
    PleaseOne: '请将',
    PleaseTwo: '币发送到',
    PleaseThree: '网络上的该地址',
    Amount: '支付数量',
    wallerAddress: '钱包地址',
    error: '付款超时，订单已关闭',
    errorTitle: '您的订单已超时请重新发起！',
    succeed: '付款成功',
    succeedTitle: "您可在订单列表中查看该订单！",
    payNumber: '支付数量',
    repayNumber: '实际支付数量',
    orderAmount: '订单金额',
    orderId: '订单编号',
    meassage: "复制成功",
    Nodata: '无数据',
    OrderError: '订单错误',
    verification: 'order_id 验证失败,请联系商家处理',
  },
}